<template lang="pug">
.cadastro-form-search-select(v-click-outside="fechar")
  .cadastro-form-search-select__control(
    :class="{ 'is-open': aberto, 'is-disabled': disabled }"
  )
    input.cadastro-form-search-select__input(
      type="text"
      :value="textoExibido"
      :placeholder="placeholder"
      :disabled="disabled"
      autocomplete="off"
      @focus="abrir"
      @input="onBusca"
    )
    img.cadastro-form-search-select__chevron(
      src="@/assets/icons/cadastro/chevron-down.svg"
      alt=""
    )

  ul.cadastro-form-search-select__dropdown(v-if="aberto && !disabled")
    li.cadastro-form-search-select__empty(v-if="!opcoesFiltradas.length")
      | Nenhum resultado encontrado
    li.cadastro-form-search-select__option(
      v-for="option in opcoesFiltradas"
      :key="optionKey(option)"
      :class="{ 'is-selected': optionValue(option) === value }"
      @mousedown.prevent="selecionar(option)"
    ) {{ optionLabel(option) }}
</template>

<script>
export default {
  name: 'CadastroFormSearchSelect',
  directives: {
    clickOutside: {
      bind (el, binding) {
        el.__clickOutsideHandler__ = (event) => {
          if (!el.contains(event.target)) {
            binding.value(event)
          }
        }
        document.addEventListener('click', el.__clickOutsideHandler__)
      },
      unbind (el) {
        document.removeEventListener('click', el.__clickOutsideHandler__)
        delete el.__clickOutsideHandler__
      }
    }
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: 'Selecione'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    primitiveOptions: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      aberto: false,
      termoBusca: ''
    }
  },
  computed: {
    textoExibido () {
      if (this.aberto) {
        return this.termoBusca
      }

      return this.value == null ? '' : this.value
    },
    opcoesFiltradas () {
      const termo = this.normalizar(this.termoBusca)

      if (!termo) {
        return this.options
      }

      return this.options.filter(option => {
        return this.normalizar(this.optionLabel(option)).includes(termo)
      })
    }
  },
  methods: {
    normalizar (texto) {
      return String(texto || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
    },
    optionKey (option) {
      return this.primitiveOptions ? option : option[this.valueKey]
    },
    optionValue (option) {
      return this.primitiveOptions ? option : option[this.valueKey]
    },
    optionLabel (option) {
      return this.primitiveOptions ? option : option[this.labelKey]
    },
    abrir () {
      if (this.disabled) {
        return
      }

      this.aberto = true
      this.termoBusca = ''
      this.$emit('focus')
    },
    fechar () {
      this.aberto = false
      this.termoBusca = ''
    },
    onBusca (event) {
      this.termoBusca = event.target.value
      this.aberto = true
    },
    selecionar (option) {
      const valor = this.optionValue(option)
      this.$emit('input', valor)
      this.fechar()
    }
  }
}
</script>

<style lang="scss" scoped>
.cadastro-form-search-select {
  position: relative;
  width: 100%;
}

.cadastro-form-search-select__control {
  position: relative;
  width: 100%;

  &.is-disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
}

.cadastro-form-search-select__input {
  appearance: none;
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  color: #141414;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  height: 40px;
  line-height: 1.43;
  padding: 0 36px 0 12px;
  width: 100%;

  &::placeholder {
    color: #8a8a8a;
    opacity: 0.5;
  }

  &:disabled {
    background: #f5f5f5;
    cursor: not-allowed;
  }

  &:focus {
    border-color: #1e174e;
    outline: none;
  }
}

.cadastro-form-search-select__control.is-open .cadastro-form-search-select__input {
  border-color: #1e174e;
}

.cadastro-form-search-select__chevron {
  height: 16px;
  pointer-events: none;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
}

.cadastro-form-search-select__dropdown {
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  list-style: none;
  margin: 4px 0 0;
  max-height: 220px;
  overflow-y: auto;
  padding: 4px 0;
  position: absolute;
  width: 100%;
  z-index: 20;
}

.cadastro-form-search-select__option,
.cadastro-form-search-select__empty {
  color: #141414;
  cursor: pointer;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  padding: 8px 12px;
}

.cadastro-form-search-select__empty {
  color: #8a8a8a;
  cursor: default;
}

.cadastro-form-search-select__option {
  &:hover,
  &.is-selected {
    background: #f5f5f5;
  }
}
</style>
